module.exports = __webpack_public_path__ + "media/Spectrum - Patterns.86a6f933.mp4";